export const stripHtmlTags = (str: string) => str.replace(/<[^>]*>/g, '');

export function cutString(s: string, n: number) {
  const cut = s.indexOf(' ', n);
  if (cut === -1) return s;
  return s.substring(0, cut)
}

export const isMobile = () => window.innerWidth <= 600;

export const isTouchDevice = () => {
  return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0));
}

export const isFilenameImage = (fileName: string) =>
  fileName.match(/\.(jpg|jpeg|png|gif)$/i);